export default __webpack_public_path__ + "static/media/en-flag.f33d8b7d.svg";